"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _reactTransitionGroup = require("react-transition-group");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _constants = require("../Search/constants");
var _selectors2 = require("./store/selectors");
var _HorizontalLoader = _interopRequireDefault(require("./components/HorizontalLoader"));
var _MoreButton = _interopRequireDefault(require("./components/MoreButton"));
var _PageDivider = _interopRequireDefault(require("./components/PageDivider"));
var _PriceAnalytics = require("./components/PriceAnalytics/PriceAnalytics");
var _Placeholder = _interopRequireDefault(require("./components/Placeholder"));
var _EmptyState = _interopRequireDefault(require("./components/EmptyState"));
var _Result = _interopRequireDefault(require("./Result"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PLACEHOLDERS = R.range(1, 5);
var mapperWithIndex = R.addIndex(R.map);
var getIsSetSeach = (0, _selectors2.createIsSetSearchSelector)();
var getIsProccess = (0, _selectors2.createIsProccessSelector)(_constants.MAIN_QUERIES);
var getIsEmptySearch = (0, _selectors2.createIsEmptySearchSelector)();
var Results = function Results(_ref) {
  var baseQueryID = _ref.queryID;
  var activePage = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getQueryParam)(state, {
      queryID: baseQueryID,
      paramName: _fn.QUERY_PARAMS.PAGE
    });
  });
  var activeCurrency = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getQueryParam)(state, {
      queryID: baseQueryID,
      paramName: _fn.QUERY_PARAMS.CURRENCY
    });
  });
  var isCompactView = (0, _reactRedux.useSelector)(_selectors2.isCompactResultsView);
  var isEmptySearch = (0, _reactRedux.useSelector)(getIsEmptySearch);
  var isProccess = (0, _reactRedux.useSelector)(getIsProccess);
  var isSetSearch = (0, _reactRedux.useSelector)(getIsSetSeach);
  var getPrices = (0, _react.useMemo)(function () {
    return isSetSearch ? (0, _selectors2.createGetPricesSelector)(_constants.MAIN_QUERIES) : R.always([]);
  }, [isSetSearch]);
  var prices = (0, _reactRedux.useSelector)(getPrices);
  var pages = R.range(1, R.inc(activePage));
  var currency = (0, _react.useMemo)(function () {
    return (0, _dictionary.getCurrencyByCode)(activeCurrency);
  }, [activeCurrency]);
  return isSetSearch && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PriceAnalytics.PriceAnalytics, {
    queryID: baseQueryID
  }), isEmptySearch && /*#__PURE__*/_react.default.createElement(_EmptyState.default, null), mapperWithIndex(function (page, index) {
    var priceByPage = R.propOr([], index, prices);
    var isActivePage = page === activePage;
    var isFirstPage = page === 1;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.root,
      key: page
    }, !isFirstPage && !R.isEmpty(priceByPage) && /*#__PURE__*/_react.default.createElement(_PageDivider.default, {
      count: priceByPage.length,
      key: "divider-".concat(page)
    }), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
      unmountOnExit: true,
      in: isProccess && isActivePage,
      timeout: 500
    }, function () {
      return /*#__PURE__*/_react.default.createElement(_HorizontalLoader.default, {
        queriesIDs: _constants.MAIN_QUERIES
      });
    }), mapperWithIndex(function (_ref2, indexOfPrice) {
      var hotelID = _ref2.hotelID,
        _ref2$offers = _slicedToArray(_ref2.offers, 1),
        _ref2$offers$ = _ref2$offers[0],
        offerID = _ref2$offers$.id,
        queryID = _ref2$offers$.queryID;
      return /*#__PURE__*/_react.default.createElement(_Result.default, {
        position: page * priceByPage.length - priceByPage.length + indexOfPrice + 1,
        compact: isCompactView,
        currency: currency,
        hotelID: hotelID,
        key: "result-".concat(hotelID),
        offerID: offerID,
        queryID: queryID
      });
    }, priceByPage), R.isEmpty(priceByPage) && isProccess && isActivePage && R.map(function (number) {
      return /*#__PURE__*/_react.default.createElement(_Placeholder.default, {
        compact: isCompactView,
        key: number
      });
    }, PLACEHOLDERS));
  }, pages), /*#__PURE__*/_react.default.createElement(_MoreButton.default, {
    queryID: baseQueryID
  }));
};
Results.propTypes = {
  queryID: _propTypes.default.string.isRequired
};
var _default = exports.default = (0, _react.memo)(Results);